import { LocStoreInstance } from ".";
import { loc } from "./loc";

export type SplitStrReplacement =
  | (string | number)[]
  | ((s: string, index: number) => any);

export function splitStr(
  s: string,
  replacements: SplitStrReplacement,
  searchWords: string[],
  stringContext: string,
  id: string,
  locStoreInstance: LocStoreInstance
): any {
  s = loc(s, searchWords, stringContext, id, locStoreInstance);

  const split = s.split(/(\{[^\}]+\})/);

  let _index = 0;
  return split
    .filter((s) => s)
    .map((s, index) => {
      try {
        if (Array.isArray(replacements) && s.match(/\{\d+\}/)) {
          _index++;
          const index = Number(s.substring(1, s.length - 1));

          return replacements[index];
        }

        if (typeof replacements === "function") {
          let fMatch = s.match(/\{.+\}/);

          if (fMatch) {
            let _s = s.substring(1, s.length - 1);
            let replaced = replacements(_s, _index++);

            if (replaced !== undefined) return replaced;
            return _s;
          }
        }

        return s;
      } catch (e) {
        return s;
      }
    })
    .join("");
}
